// Generated by scripts/build-ui-icons.mjs.
export { Storefront as default } from "../ui/glyphs-7";
